import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import IForecast_Group from "../../../models/IForecast_Group";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    forecastGroup?: IForecast_Group;
};

type State = {};

class ForecastDetail extends Component<Props, State> {
    render() {
        let yearDetail = "";
        let periodDetail = "";

        if (this.props.forecastGroup) {
            yearDetail = moment(this.props.forecastGroup.period_year).format("YYYY");
            periodDetail = moment(this.props.forecastGroup.period_start).quarter() <= 2 ? "H1" : "H2";
        }
        return (
            <div className={"ForecastDetail"}>
                <table className={"table table-dark table-responsive w-auto d-inline-flex"}>
                    <tbody>
                        {this.props.userModel.isSupplierUser ? (
                            <tr>
                                <th>
                                    <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={this.props.supplierModel} />
                                </th>
                                <td>
                                    {this.props.forecastGroup && this.props.forecastGroup.Vendor
                                        ? this.props.forecastGroup.Vendor.name
                                        : ""}
                                </td>
                            </tr>
                        ) : null}
                        <tr>
                            <th>
                                <OwLabel title={"catalog"} />
                            </th>
                            <td>{this.props.forecastGroup ? this.props.forecastGroup.Catalog?.name : ""}</td>
                        </tr>

                        <tr>
                            <th>
                                <OwLabel title={"year"} />
                            </th>
                            <td>{yearDetail}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"period"} />
                            </th>
                            <td>{periodDetail}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ForecastDetail;
